/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Cli_Table_OptionInputs */

const en_options_cli_table_option = /** @type {(inputs: Options_Cli_Table_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Option`)
};

const fr_options_cli_table_option = /** @type {(inputs: Options_Cli_Table_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Option`)
};

const de_options_cli_table_option = /** @type {(inputs: Options_Cli_Table_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Option`)
};

const it_options_cli_table_option = /** @type {(inputs: Options_Cli_Table_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzione`)
};

const ru_options_cli_table_option = /** @type {(inputs: Options_Cli_Table_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вариант`)
};

const es_options_cli_table_option = /** @type {(inputs: Options_Cli_Table_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opción`)
};

const zh_cn2_options_cli_table_option = /** @type {(inputs: Options_Cli_Table_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选项`)
};

const ja_options_cli_table_option = /** @type {(inputs: Options_Cli_Table_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オプション`)
};

const hi_options_cli_table_option = /** @type {(inputs: Options_Cli_Table_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विकल्प`)
};

const pt_pt2_options_cli_table_option = /** @type {(inputs: Options_Cli_Table_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opção`)
};

/**
* | output |
* | --- |
* | "Option" |
*
* @param {Options_Cli_Table_OptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_table_option = /** @type {((inputs?: Options_Cli_Table_OptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_Table_OptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_cli_table_option(inputs)
	if (locale === "de") return de_options_cli_table_option(inputs)
	if (locale === "it") return it_options_cli_table_option(inputs)
	if (locale === "ru") return ru_options_cli_table_option(inputs)
	if (locale === "es") return es_options_cli_table_option(inputs)
	if (locale === "zh-CN") return zh_cn2_options_cli_table_option(inputs)
	if (locale === "ja") return ja_options_cli_table_option(inputs)
	if (locale === "hi") return hi_options_cli_table_option(inputs)
	if (locale === "pt-PT") return pt_pt2_options_cli_table_option(inputs)
	return en_options_cli_table_option(inputs)
});